import type { ReactNode } from 'react';

import classes from './GreyContainer.module.css';

type Props = {
    fullHeight?: boolean;
    className?: string;
    children?: ReactNode;
};

const GreyContainer = (props: Props) => (
    <div className={`${classes.greyContainer} ${props.className} ${props.fullHeight && classes.fullHeight}`}>
        {props.children}
    </div>
);

export default GreyContainer;
